import Hero from "../components/home/Hero";
import EarningsProof from "../components/home/EarningsProof";
import Pillars from "../components/home/Pillars";
import HowItWorks from "../components/home/HowItWorks";
import FinalCta from "../components/home/FinalCta";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <EarningsProof />
      <Pillars />
      <HowItWorks />
      <FinalCta />
    </main>
  );
}
